document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.graze-fade').forEach(function (el) {
    observer.observe(el);
  });

  // Stagger children inside grid containers
  document.querySelectorAll('.graze-stagger').forEach(function (parent) {
    parent.querySelectorAll('.graze-fade').forEach(function (child, i) {
      child.style.transitionDelay = (i * 0.1) + 's';
    });
  });
});